import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorderOutlined';
import FavoriteIcon from '@mui/icons-material/FavoriteOutlined';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import React from 'react';

/**
 * BoxFileお気に入りアイコン Component
 */

// 2024.5.8 MyMine Version1.5対応 Modify Start
export const BoxFileFavorite = ({ isFavorite, favoriteAction, unFavoriteAction, color }) => {
  return isFavorite
    ? <StarIcon sx={{ cursor: 'pointer', color: color ?? "black" }} fontSize='small' onClick={favoriteAction} />
    : <StarBorderIcon sx={{ cursor: 'pointer', color: color ?? "black" }} fontSize='small' onClick={unFavoriteAction} />;
  // 2024.5.8 MyMine Version1.5対応 Modify End
};

/**
 * ITAppお気に入りアイコン Component
 */
export const ItAppFavorite = ({ isFavorite, favoriteAction, unFavoriteAction }) => {
  return isFavorite
    ? <FavoriteIcon sx={{ cursor: 'pointer', color: 'red' }} fontSize='large' onClick={favoriteAction} />
    : <FavoriteBorderIcon sx={{ cursor: 'pointer', color: 'red' }} fontSize='large' onClick={unFavoriteAction} />;
};